import * as React from 'react';
import Glyphicon from 'source/app/presentation/Shared/Glyphicon/Glyphicon';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from '../../../../Shared/Render';
import { AreDreamsFiltered } from "source/app/presentation/MainPanel/Dreams/Helpers/AreDreamsFiltered";
import { IDreamsState } from '../../IDreamsState';
import * as styles from './DreamToolsLabel.css';

export function DreamToolsIcon({ state, setState }: { state: IDreamsState; setState: Function }) {
	return (
		<span>
			<span>Filters</span>
			<Render id="isFilteredIcon" when={AreDreamsFiltered(state)} withClasses={styles.isFilteredIcon}>
				<Glyphicon icon={EGlyphicon.filter} />
			</Render>
		</span>
	);
}
